import { Drawer } from "@mui/material";

// component
import LeftNavigation from "./LeftNavigation";
import LogoBottom from "./LogoBottom";

const LHSNavigation: React.FC = (): React.ReactElement => {
  return (
    <Drawer
      data-testid="navigation-drawer"
      sx={{
        width: 200,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 200,
          boxSizing: "border-box",
          background: "rgba(59, 214, 255, 0.10)",
          color: "white",
          padding: "10px",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <LeftNavigation/>  
      <LogoBottom/>      
    </Drawer>        
  )
};

export default LHSNavigation;